import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Siren } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { API_URL } from './chatShared';
import { URGENCY } from './ChatUrgency';

const age = (iso) => {
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (m < 60) return `há ${m} min`;
  const h = Math.floor(m / 60);
  return h < 24 ? `há ${h}h${m % 60 ? ` ${m % 60}min` : ''}` : `há ${Math.floor(h / 24)} dia(s)`;
};

export const useUrgentList = (enabled) => {
  const [list, setList] = useState([]);
  useEffect(() => {
    if (!enabled) return undefined;
    const load = () => axios.get(`${API_URL}/chat/urgent`).then((r) => setList(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [enabled]);
  return list;
};

export const UrgentListDialog = ({ open, onClose, list, onOpenConv }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-lg" data-testid="chat-urgent-dialog" aria-describedby={undefined}>
      <DialogHeader><DialogTitle className="flex items-center gap-2 text-rose-700"><Siren className="w-5 h-5" />Pedidos urgentes por resolver ({list.length})</DialogTitle></DialogHeader>
      {!list.length && <p className="text-sm text-slate-500 py-6 text-center">Não há pedidos urgentes por resolver.</p>}
      <div className="max-h-[60vh] overflow-y-auto divide-y divide-slate-100">
        {list.map((m) => {
          const old = Date.now() - new Date(m.created_at).getTime() > 2 * 3600000;
          return (
            <button key={m.id} type="button" onClick={() => { onOpenConv(m); onClose(); }} className="w-full text-left py-2.5 px-1 hover:bg-slate-50 transition-colors" data-testid={`chat-urgent-item-${m.id}`}>
              <span className="flex items-center gap-2 text-xs">
                <span className={`font-bold uppercase rounded-full border px-1.5 py-0.5 text-[10px] ${URGENCY[m.urgency]?.chip}`}>{URGENCY[m.urgency]?.label}</span>
                <span className="font-semibold text-slate-700 truncate flex-1">{m.conversation_name}</span>
                <span className={`shrink-0 font-semibold ${old ? 'text-rose-600' : 'text-slate-500'}`}>{age(m.created_at)}</span>
              </span>
              <span className="block text-sm text-slate-600 truncate mt-0.5"><b>{m.sender_name}:</b> {m.text || m.file?.name || ''}</span>
            </button>
          );
        })}
      </div>
    </DialogContent>
  </Dialog>
);
